// Import gqlV2 from v2 generated code
import { gqlV2 } from '@fly/store';

/**
 * GraphQL v2 queries - uses Relay-style connections with edges/nodes
 * These queries work with /fly/api/v2/graphql endpoint
 */

export const getRepositoryNamesQuery = gqlV2(/* GraphQL */ `
  query GetRepositoryNames {
    flyGitRepositories {
      searchRepositories {
        edges {
          node {
            name
            owner
            url
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
  }
`);

export const getRepositoriesQuery = gqlV2(/* GraphQL */ `
  query GetRepositories(
    $refreshCache: Boolean
    $owner: String
    $name: String
    $artifactsFirst: Int = 50
  ) {
    flyGitRepositories {
      searchRepositories(
        where: { refreshCache: $refreshCache, owner: $owner, name: $name }
      ) {
        edges {
          node {
            name
            owner
            url
            artifactsCount
            ciConfigured
            configuredWorkflowsCount
            latestArtifact {
              name
              uploadedLocally
              lastUploadTimestamp
            }
            artifacts(first: $artifactsFirst) {
              edges {
                node {
                  name
                  packageType
                  latestVersion {
                    name
                    lastUploadTimestamp
                  }
                }
              }
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
`);

export const getRegistryInsightsQuery = gqlV2(/* GraphQL */ `
  query GetRegistryInsights {
    flyOperationalInfo {
      getRegistryInsights {
        repositoriesCount
        repositoriesConnected
      }
    }
  }
`);

export const getRepositoryArtifactsQuery = gqlV2(/* GraphQL */ `
  query GetRepositoryArtifacts(
    $name: String!
    $owner: String!
    $first: Int = 50
    $releasesFirst: Int = 50
  ) {
    flyGitRepositories {
      getRepository(input: { name: $name, owner: $owner }) {
        name
        owner
        url
        packageManagers
        artifacts(first: $first) {
          edges {
            node {
              name
              packageType
              versionsCount
              hasPublicDistributedArtifact
              latestVersion {
                name
                uploadedBy
                lastUploadTimestamp
                uploadedLocally
                releases(first: $releasesFirst) {
                  edges {
                    node {
                      name
                      number
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export const getRepositoryWorkflowsQuery = gqlV2(/* GraphQL */ `
  query GetRepositoryWorkflows(
    $name: String!
    $owner: String!
    $first: Int = 50
  ) {
    flyGitRepositories {
      getRepository(input: { name: $name, owner: $owner }) {
        name
        owner
        url
        workflows(first: $first) {
          edges {
            node {
              id
              name
              url
              ciConfigured
              latestDownloadTimestamp
              latestUploadTimestamp
            }
          }
        }
      }
    }
  }
`);

export const getRepositoryReleaseQuery = gqlV2(/* GraphQL */ `
  query GetRepositoryRelease(
    $name: String!
    $owner: String!
    $workflowName: String!
    $workflowRunNumber: String!
  ) {
    flyGitRepositories {
      getRepository(
        input: {
          name: $name
          owner: $owner
          workflowName: $workflowName
          workflowRunNumber: $workflowRunNumber
        }
      ) {
        workflows(first: 1) {
          edges {
            node {
              id
              name
              url
              releases(first: 1) {
                edges {
                  node {
                    id
                    name
                    number
                    url
                    summary
                    title
                    shortSummary
                    fullSummary
                    status
                    timestamp
                    uploadedBy
                    hasPublicArtifacts
                    decisionRecords {
                      id
                      title
                      recordType
                      description
                      createdTime
                      createdBy
                    }
                    pullRequests {
                      edges {
                        node {
                          title
                          url
                          description
                          timestamp
                          author
                        }
                      }
                    }
                    commits {
                      edges {
                        node {
                          sha
                          message
                          url
                          body
                          timestamp
                          author
                        }
                      }
                    }
                    environments {
                      id
                      name
                      isLatest
                    }
                    uploadedArtifacts {
                      edges {
                        node {
                          name
                          packageType
                          versionsCount
                          versions(first: 50) {
                            edges {
                              node {
                                name
                                lastUploadTimestamp
                                uploadedBy
                                uploadedLocally
                                distribution {
                                  distributedTime
                                  distributedBy
                                  downloadCount
                                  distributionUrl
                                }
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export const getAllArtifactsQuery = gqlV2(/* GraphQL */ `
  query GetAllArtifacts(
    $search: String
    $packageTypes: [String]
    $names: [String]
    $repositoryOwner: String
    $repositoryName: String
    $first: Int
    $after: String
  ) {
    flyArtifacts {
      searchArtifacts(
        where: {
          search: $search
          packageTypeIn: $packageTypes
          names: $names
          repositoryOwner: $repositoryOwner
          repositoryName: $repositoryName
        }
        first: $first
        after: $after
      ) {
        edges {
          node {
            name
            packageType
            lastUploadTimestamp
            versionsCount
            hasPublicDistributedArtifact
            latestVersion {
              uploadedBy
              uploadedLocally
              name
              releases(first: 1) {
                edges {
                  node {
                    name
                    number
                  }
                }
              }
            }
            repository {
              name
              owner
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`);

export const getArtifactDetailsQuery = gqlV2(/* GraphQL */ `
  query GetArtifactDetails(
    $name: String
    $packageType: String
    $first: Int
    $versionsFirst: Int
    $versionsAfter: String
    $versionsSearch: String
    $releasesFirst: Int = 1
  ) {
    flyArtifacts {
      searchArtifacts(
        where: { name: $name, packageTypeIn: [$packageType] }
        first: $first
      ) {
        edges {
          node {
            packageType
            name
            versions(
              first: $versionsFirst
              after: $versionsAfter
              where: { search: $versionsSearch }
            ) {
              edges {
                node {
                  name
                  lastUploadTimestamp
                  uploadedBy
                  uploadedLocally
                  tags
                  distribution {
                    distributedTime
                    distributedBy
                    downloadCount
                    distributionUrl
                  }
                  url
                  releases(first: $releasesFirst) {
                    edges {
                      node {
                        name
                        number
                        url
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }
      }
    }
  }
`);

export const getArtifactFilesQuery = gqlV2(/* GraphQL */ `
  query GetArtifactFiles(
    $name: String!
    $packageVersion: String!
    $packageType: String
    $first: Int
    $after: String
  ) {
    flyArtifacts {
      searchDistributedFiles(
        where: {
          packageName: $name
          packageVersion: $packageVersion
          packageType: $packageType
        }
        first: $first
        after: $after
      ) {
        edges {
          node {
            fileName
            sha256
            downloadCount
            isPublic
            url
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
  }
`);

export const getRepositoryReleasesQuery = gqlV2(/* GraphQL */ `
  query GetRepositoryReleases(
    $first: Int = 50
    $after: String
    $repository: String!
    $workflowName: String
    $environmentIDs: [ID!]
    $uploaderNames: [String!]
    $search: String
    $lastRun: String
    $since: DateTime
    $until: DateTime
    $runIds: [String!]
    $deployment: DeploymentRefInput
    $deploymentId: ID
  ) {
    flyReleases {
      getReleases(
        where: {
          repository: $repository
          workflowName: $workflowName
          hasArtifacts: true
          environmentIDs: $environmentIDs
          uploaderNames: $uploaderNames
          search: $search
          lastRun: $lastRun
          since: $since
          until: $until
          runIds: $runIds
          deployment: $deployment
          deploymentId: $deploymentId
        }
        first: $first
        after: $after
      ) {
        totalCount
        uploaders
        environments {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            number
            url
            timestamp
            status
            uploadedBy
            title
            shortSummary
            summary
            hasPublicArtifacts
            environments {
              id
              name
              isLatest
            }
            publicArtifacts {
              distribution {
                downloadCount
              }
            }
          }
          cursor
        }
      }
    }
  }
`);

export const getWorkflowNamesQuery = gqlV2(/* GraphQL */ `
  query GetWorkflowNames($repository: String!, $hasArtifacts: Boolean) {
    flyReleases {
      searchWorkflowNames(repository: $repository, hasArtifacts: $hasArtifacts)
    }
  }
`);
